import { DEFAULT_AUDIENCE_FILTERS } from "../constants";

import type { AudienceFilters } from "../types";

export default function useAudienceFilters(
  selectedFilters: AudienceFilters,
  setSelectedFilters: (newFilters: AudienceFilters) => void,
) {
  function toggleFilterItem(
    key: keyof Omit<AudienceFilters, "premium" | "keyword">,
    id: string,
  ) {
    if (selectedFilters[key].includes(id)) {
      setSelectedFilters({
        ...selectedFilters,
        [key]: selectedFilters[key].filter(
          (prevFilterId) => prevFilterId !== id,
        ),
      });
    } else {
      setSelectedFilters({
        ...selectedFilters,
        [key]: [...selectedFilters[key], id],
      });
    }
  }

  function setFilterValue<T extends keyof AudienceFilters>(
    key: T,
    value: AudienceFilters[T],
  ) {
    setSelectedFilters({ ...selectedFilters, [key]: value });
  }

  function resetAllFilters() {
    setSelectedFilters(DEFAULT_AUDIENCE_FILTERS);
  }

  const { keyword: _, ...filters } = selectedFilters;
  const hasFilters = Object.values(filters).some((filter) =>
    Array.isArray(filter) ? !!filter.length : !!filter,
  );

  return {
    toggleFilterItem,
    setFilterValue,
    resetAllFilters,
    hasFilters,
  };
}
